import { FormLayout } from 'components/common'
import { DynamicInputList } from 'components/common/dynamicInputList'
import { UseFormSetValue, FieldValues, FieldErrors } from 'react-hook-form'

type Props = {
  setValue: UseFormSetValue<FieldValues>
  reason?: string[]
  condition?: string[]
  errors?: FieldErrors<FieldValues>
}

const RmaSection = ({ setValue, reason, condition, errors }: Props) => {
  return (
    <>
      <h3 className="title">RMA Configuration</h3>
      <FormLayout>
        <div className="flex w-full gap-3">
          <aside className="w-full">
            {' '}
            <DynamicInputList
              label="Reason"
              name="rmaReasons"
              placeholder="Add RMA Reason"
              setValue={setValue}
              defaultValues={reason}
              errors={errors}
            />
          </aside>
          <aside className="w-full">
            <DynamicInputList
              label="Conditions"
              name="rmaConditions"
              placeholder="Add RMA Condition"
              setValue={setValue}
              defaultValues={condition}
              errors={errors}
            />
          </aside>
        </div>
      </FormLayout>
    </>
  )
}

export default RmaSection
